import * as React from "react"
import {connect} from "react-redux"
import {map as _map} from "lodash"
import { IPatientHabits } from "@curefit/ehr-common";
import {IAppState} from "../../../models/IAppState";
import IHabitStaticData from "../../../models/staticData/IHabitStaticData";
import HabitQuestionItem from "../../HabitQuestionItem";
import IHabitNew from "../../../models/IHabitNew";
import ModelFactory from "../../../models/ModelFactory";

/**
 * Created by aditya on 20/02/18.
 */

export interface PatientHabitEditorNewProps {
    updatedHabits: {item: IHabitNew}[],
    updateHabits: (updatedHabits: {item: IHabitNew}[]) => void,
    habitStaticInfo: IHabitStaticData
}

class PatientHabitEditor extends React.Component<PatientHabitEditorNewProps> {

    constructor(props: PatientHabitEditorNewProps) {
        super(props);
    }

    onHabitRemove = (index: number) => {
        let currUpdatedHabits = Object.assign([], this.props.updatedHabits);
        currUpdatedHabits.splice(index, 1);
        this.props.updateHabits(currUpdatedHabits);
    }

    onHabitChange = (patientHabit: IPatientHabits, index: number) => {
        let currUpdatedHabits = Object.assign([], this.props.updatedHabits);
        currUpdatedHabits[index] = patientHabit;
        this.props.updateHabits(currUpdatedHabits);
    }

    onHabitQuestionItemChange = (frequency: string, name: string) => {
        let currUpdatedHabits = Object.assign([], this.props.updatedHabits);
        let index = currUpdatedHabits.map(habit => habit.item.habitName).indexOf(name);
        if (index >= 0) currUpdatedHabits[index].item.frequency = frequency;
        else {
            let newHabit = ModelFactory.createNewHabit();
            newHabit.habitName = name;
            newHabit.frequency = frequency;
            currUpdatedHabits.push({item: newHabit});
        }
        this.props.updateHabits(currUpdatedHabits);
    }

    onHabitQuestionItemRemove = (name: string) => {
        let currUpdatedHabits = Object.assign([], this.props.updatedHabits);
        let index = currUpdatedHabits.map(habit => habit.item.habitName).indexOf(name);
        if (index >= 0) currUpdatedHabits.splice(index, 1);
        this.props.updateHabits(currUpdatedHabits);
    }

    render() {
        let questionsList = this.props.habitStaticInfo.values;
        let updatedHabitItems = this.props.updatedHabits.map(item => item.item);
        return (
            <div className="patient-habit-editor">
                {
                    questionsList.length &&
                    <div>
                        {
                            _map(questionsList, (question, index) => {
                                let habitItem = ModelFactory.createNewHabit();
                                habitItem.habitName = question.id;
                                let filteredHabitItems = updatedHabitItems.filter(item => item.habitName === question.id);
                                if (filteredHabitItems.length !== 0) habitItem = filteredHabitItems[0];
                                return <HabitQuestionItem
                                    key={`habit-question-item-editor-${index}`}
                                    questionText={question.questionTitle}
                                    frequencyItems={question.frequency}
                                    onHabitChange={this.onHabitQuestionItemChange}
                                    onHabitRemove={this.onHabitQuestionItemRemove}
                                    habitItem={habitItem}/>
                            })
                        }
                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState) => {
    let { allStaticDataNew } = state;
    return { habitStaticInfo: allStaticDataNew.habits }
}

export default connect(mapStateToProps, () => {return {}})(PatientHabitEditor)